import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FiSun,
  FiStar,
  FiGift,
  FiClock,
  FiMapPin,
  FiPhone,
  FiMail,
  FiSearch,
  FiX,
  FiCalendar,
  FiCheck,
  FiShare2,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import {
  GiTempleGate,
  GiFlowerPot,
  GiLotus,
  GiIndianPalace,
  GiFire,
  GiBowlOfRice,
  GiClothes,
} from "react-icons/gi";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";

export default function TempleSevasPage() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSeva, setSelectedSeva] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [shareSevaId, setShareSevaId] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const sevaCategories = [
    {
      id: "all",
      name: "All Kits",
      icon: <GiTempleGate />,
      color: "from-orange-500 to-red-600",
    },
    {
      id: "Festival kits",
      name: "Festival kits",
      icon: <FiSun />,
      color: "from-yellow-500 to-orange-600",
    },
    {
       id: "daily",
    name: "Daily Pooja Kits",
      icon: <FiStar />,
      color: "from-purple-500 to-pink-600",
    },
    {
     id: "special",
    name: "Special Pooja Kits",
      icon: <FiGift />,
      color: "from-pink-500 to-red-600",
    },
    {
      id: "homa",
    name: "Homa Kits",
      icon: <GiFlowerPot />,
      color: "from-blue-500 to-cyan-600",
    },
    {
      id: "abhishekam",
    name: "Abhishekam Kits",
      icon: <GiFire />,
      color: "from-red-500 to-orange-600",
    },
    {
          id: "archana",
    name: "Archana Kits",

      icon: <GiIndianPalace />,
      color: "from-indigo-500 to-purple-600",
    },
    {
       id: "annadanam",
    name: "Annadanam Kits",
      icon: <GiLotus />,
      color: "from-rose-500 to-pink-600",
    },
    {
         id: "vasthra",
    name: "Vasthra Kits",

      icon: <GiBowlOfRice />,
      color: "from-green-500 to-emerald-600",
    },
    {
      id: "vasthra",
      name: "Vasthra kits",
      icon: <GiClothes />,
      color: "from-teal-500 to-cyan-600",
    },
  ];

  const temples = {
    1: {
      name: "Sri Chamundeshwari Temple",
      location: "Mysuru, Karnataka",
      deity: "Goddess Chamundeshwari",
      address: "Chamundi Hills, Mysuru - 570008",
      contact: "+91 821-2512235",
      email: "info@chamundeshwari.org",
      timings: "7:30 AM - 2:00 PM, 3:30 PM - 9:00 PM",
      description:
        "Ancient temple atop Chamundi Hills, dedicated to Goddess Chamundeshwari, the presiding deity of Mysore.",
      facilities: ["Free Prasadam", "Parking", "Accommodation", "Hill View"],
      profileImage:
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
      ],
    },
    2: {
      name: "Udupi Sri Krishna Temple",
      location: "Udupi, Karnataka",
      deity: "Lord Krishna",
      address: "Car Street, Udupi - 576101",
      contact: "+91 820-2520176",
      email: "info@udupikshetra.org",
      timings: "5:30 AM - 1:00 PM, 3:00 PM - 9:00 PM",
      description:
        "Famous Krishna temple known for its unique idol worship through a silver-plated window.",
      facilities: [
        "Anna Prasadam",
        "Heritage Site",
        "Temple Museum",
        "Vedic School",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1609619385002-f40fd7e3091f?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1609619385002-f40fd7e3091f?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
      ],
    },
    3: {
      name: "Gokarna Mahabaleshwara Temple",
      location: "Gokarna, Karnataka",
      deity: "Lord Shiva",
      address: "Gokarna Beach Road, Gokarna - 581326",
      contact: "+91 8386-256320",
      email: "info@gokarna.org",
      timings: "6:00 AM - 1:00 PM, 5:00 PM - 8:30 PM",
      description:
        "One of the seven Mukti Stalas, housing the Atmalinga of Lord Shiva.",
      facilities: [
        "Beach View",
        "Guesthouse",
        "Prasadam Counter",
        "Holy Bath Ghat",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
      ],
    },
    4: {
      name: "Murudeshwar Temple",
      location: "Murudeshwar, Karnataka",
      deity: "Lord Shiva",
      address: "Murudeshwar Beach, Bhatkal - 581350",
      contact: "+91 8385-260218",
      email: "info@murudeshwar.org",
      timings: "6:00 AM - 8:00 PM",
      description:
        "Famous for its towering 123-feet Shiva statue and scenic coastal location.",
      facilities: [
        "Beach Access",
        "Statue Viewing",
        "Museum",
        "Water Sports Nearby",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
      ],
    },
    5: {
      name: "Kollur Mookambika Temple",
      location: "Kollur, Karnataka",
      deity: "Goddess Mookambika",
      address: "Kollur Village, Kundapura - 576220",
      contact: "+91 8258-277212",
      email: "info@mookambika.org",
      timings: "4:00 AM - 1:30 PM, 3:00 PM - 9:00 PM",
      description:
        "Ancient Shakti Peetha dedicated to Goddess Mookambika, surrounded by Western Ghats forest.",
      facilities: ["Accommodation", "Annadanam", "Parking", "Kodachadri Trek"],
      profileImage:
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
      ],
    },
    6: {
      name: "Kukke Subramanya Temple",
      location: "Sullia, Karnataka",
      deity: "Lord Subramanya",
      address: "Kukke Village, Sullia Taluk - 574239",
      contact: "+91 8257-258212",
      email: "info@kukkesubramanya.org",
      timings: "5:30 AM - 2:00 PM, 5:00 PM - 9:00 PM",
      description:
        "Famous temple for Sarpa Dosha rituals, nestled in the Western Ghats.",
      facilities: ["Sarpa Samskara", "River Bath", "Accommodation", "Prasadam"],
      profileImage:
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
      ],
    },
    7: {
      name: "Dharmasthala Manjunatha Temple",
      location: "Dharmasthala, Karnataka",
      deity: "Lord Manjunatha",
      address: "Dharmasthala, Belthangady - 574216",
      contact: "+91 8256-277255",
      email: "info@dharmasthala.org",
      timings: "6:00 AM - 2:00 PM, 5:30 PM - 9:00 PM",
      description:
        "Unique temple managed by Jain administration dedicated to Lord Shiva, known for free meals.",
      facilities: [
        "Free Meals",
        "Accommodation",
        "Museum",
        "Educational Trust",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
      ],
    },
    8: {
      name: "Sringeri Sharada Peetham",
      location: "Sringeri, Karnataka",
      deity: "Goddess Sharada",
      address: "Sringeri Village, Chikkamagaluru - 577139",
      contact: "+91 8265-250125",
      email: "info@sringeri.net",
      timings: "6:00 AM - 1:00 PM, 3:00 PM - 8:30 PM",
      description:
        "One of the four Advaita Vedanta mathas established by Adi Shankaracharya.",
      facilities: ["Vedic Learning", "Library", "Guesthouse", "River View"],
      profileImage:
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
      ],
    },
    9: {
      name: "Talacauvery Temple",
      location: "Bhagamandala, Karnataka",
      deity: "Goddess Kaveri",
      address: "Talacauvery, Kodagu - 571212",
      contact: "+91 8272-228506",
      email: "info@talacauvery.org",
      timings: "6:00 AM - 6:00 PM",
      description: "Sacred birthplace of River Kaveri in the Brahmagiri hills.",
      facilities: [
        "Hill Station",
        "Natural Spring",
        "Scenic Views",
        "Trekking",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
      ],
    },
    10: {
      name: "Horanadu Annapoorneshwari Temple",
      location: "Horanadu, Karnataka",
      deity: "Goddess Annapoorneshwari",
      address: "Horanadu Village, Chikkamagaluru - 577433",
      contact: "+91 8265-279228",
      email: "info@horanadu.org",
      timings: "6:00 AM - 1:00 PM, 3:00 PM - 9:00 PM",
      description:
        "Beautiful temple in Western Ghats dedicated to Goddess Annapoorneshwari.",
      facilities: [
        "Free Meals",
        "Accommodation",
        "River Nearby",
        "Western Ghats View",
      ],
      profileImage:
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=400&h=300&fit=crop",
      galleryImages: [
        "https://images.unsplash.com/photo-1567608346359-6e9c3d9e5a36?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1580479839647-fa04d46d9db6?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1603048719539-9ecb4aa395e3?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1604608672516-f1b9b1d37076?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=600&fit=crop",
      ],
    },
  };

  const sevas = [
    {
      id: 1,
      name: "Chamundi Abhisheka",
      templeId: 1,
      category: "abhishekam",
      description:
        "Sacred abhishekam to Goddess Chamundeshwari with milk, honey, and sacred waters",
      duration: "45 mins",
      price: "₹500",
      time: "7:30 AM - 8:15 AM",
      benefits: ["Divine grace", "Protection", "Prosperity"],
      includes: [
        "Milk abhishekam",
        "Honey offering",
        "Flower decoration",
        "Sacred mantras",
      ],
    },
    {
      id: 2,
      name: "Kumkumarchana",
      templeId: 1,
      category: "archana",
      description:
        "Traditional kumkuma archana for the Goddess with 1008 names chanting",
      duration: "30 mins",
      price: "₹300",
      time: "6:00 PM - 6:30 PM",
      benefits: ["Family welfare", "Peace", "Divine blessings"],
      includes: [
        "Kumkuma offering",
        "1008 names chanting",
        "Aarti",
        "Prasadam",
      ],
    },
    {
      id: 3,
      name: "Mahishasura Mardini Archana",
      templeId: 1,
      category: "special",
      description: "Special worship commemorating the victory over Mahishasura",
      duration: "1 hour",
      price: "₹1,100",
      time: "5:00 PM - 6:00 PM",
      benefits: ["Victory over obstacles", "Strength", "Courage"],
      includes: [
        "Special puja",
        "108 names chanting",
        "Naivedyam",
        "Sacred ash",
      ],
    },
    {
      id: 4,
      name: "Ekantha Seva",
      templeId: 2,
      category: "daily",
      description:
        "Evening aarti and special darshan through the silver window",
      duration: "30 mins",
      price: "₹200",
      time: "8:30 PM - 9:00 PM",
      benefits: ["Peaceful sleep", "Mental peace", "Krishna's grace"],
      includes: [
        "Aarti darshan",
        "Special prayers",
        "Tulasi offering",
        "Prasadam",
      ],
    },
    {
      id: 5,
      name: "Krishna Abhisheka",
      templeId: 2,
      category: "abhishekam",
      description: "Milk and honey abhishekam with Vishnu Sahasranama chanting",
      duration: "45 mins",
      price: "₹750",
      time: "6:00 AM - 6:45 AM",
      benefits: ["Spiritual growth", "Devotion", "Divine love"],
      includes: [
        "Milk abhishekam",
        "Sahasranama chanting",
        "Flower decoration",
        "Butter offering",
      ],
    },
    {
      id: 6,
      name: "Tulasi Seva",
      templeId: 2,
      category: "daily",
      description: "Sacred Tulasi plant worship and offering to Lord Krishna",
      duration: "20 mins",
      price: "₹150",
      time: "5:00 PM - 5:20 PM",
      benefits: ["Health", "Purification", "Divine blessings"],
      includes: ["Tulasi worship", "Water offering", "Aarti", "Sacred leaves"],
    },
    {
      id: 7,
      name: "Atmalinga Abhisheka",
      templeId: 3,
      category: "abhishekam",
      description: "Sacred abhishekam to the self-manifested Atmalinga",
      duration: "1 hour",
      price: "₹1,000",
      time: "6:30 AM - 7:30 AM",
      benefits: ["Moksha", "Liberation", "Spiritual awakening"],
      includes: [
        "Special abhishekam",
        "Rudram chanting",
        "Bilva leaves",
        "Sacred ash",
      ],
    },
    {
      id: 8,
      name: "Rudrabhisheka",
      templeId: 3,
      category: "abhishekam",
      description: "11 Rudra abhishekam with Vedic chanting by the sea",
      duration: "2 hours",
      price: "₹3,500",
      time: "7:00 AM - 9:00 AM",
      benefits: ["Health", "Prosperity", "Shiva's blessings"],
      includes: [
        "11 types of abhishekam",
        "Vedic mantras",
        "Complete puja items",
        "Prasadam",
      ],
    },
    {
      id: 9,
      name: "Panchamrita Abhisheka",
      templeId: 3,
      category: "daily",
      description: "Abhishekam with five sacred nectars",
      duration: "30 mins",
      price: "₹500",
      time: "6:00 PM - 6:30 PM",
      benefits: ["Purification", "Peace", "Contentment"],
      includes: ["Five nectars", "Mantras", "Flower offering", "Vibhuti"],
    },
    {
      id: 10,
      name: "Maha Shivratri Abhisheka",
      templeId: 4,
      category: "special",
      description:
        "Grand abhishekam at the world's second tallest Shiva statue",
      duration: "1.5 hours",
      price: "₹2,100",
      time: "6:00 AM - 7:30 AM",
      benefits: ["Massive blessings", "Success", "Protection"],
      includes: [
        "Grand abhishekam",
        "Special puja",
        "Bel patra offering",
        "Prasadam",
      ],
    },
    {
      id: 11,
      name: "Bilva Archana",
      templeId: 4,
      category: "archana",
      description: "Sacred Bilva leaf offering with Shiva mantras",
      duration: "30 mins",
      price: "₹300",
      time: "7:00 AM - 7:30 AM",
      benefits: ["Shiva's grace", "Devotion", "Spiritual merit"],
      includes: ["Bilva leaves", "Mantras", "Water offering", "Aarti"],
    },
    {
      id: 12,
      name: "Mookambika Sahasranama Archana",
      templeId: 5,
      category: "archana",
      description: "Chanting 1000 names of Goddess Mookambika",
      duration: "1 hour",
      price: "₹800",
      time: "6:00 AM - 7:00 AM",
      benefits: ["Knowledge", "Wisdom", "Speech clarity"],
      includes: [
        "1000 names chanting",
        "Flower offering",
        "Kumkuma",
        "Prasadam",
      ],
    },
    {
      id: 13,
      name: "Ganapathi Homa",
      templeId: 1,
      category: "homa",
      description: "Sacred fire ritual to Lord Ganesha for removing obstacles",
      duration: "2 hours",
      price: "₹2,500",
      time: "7:00 AM - 9:00 AM",
      benefits: ["Remove obstacles", "Success", "New beginnings"],
      includes: [
        "Homa ceremony",
        "108 offerings",
        "Vedic chanting",
        "Sacred ash",
      ],
    },
    {
      id: 14,
      name: "Navagraha Homa",
      templeId: 2,
      category: "homa",
      description:
        "Planetary peace fire ritual for harmonizing cosmic influences",
      duration: "3 hours",
      price: "₹5,000",
      time: "6:00 AM - 9:00 AM",
      benefits: ["Planetary peace", "Good fortune", "Health"],
      includes: [
        "Nine planet worship",
        "Fire offerings",
        "Mantras for all planets",
        "Prasadam",
      ],
    },
    {
      id: 15,
      name: "Lakshmi Kalyanam",
      templeId: 5,
      category: "kalyanam",
      description: "Divine marriage ceremony of Goddess Lakshmi",
      duration: "2.5 hours",
      price: "₹3,500",
      time: "9:00 AM - 11:30 AM",
      benefits: ["Wealth", "Prosperity", "Marital harmony"],
      includes: [
        "Complete kalyanam ritual",
        "Decoration",
        "Sacred offerings",
        "Special prasadam",
      ],
    },
    {
      id: 16,
      name: "Annadanam Seva",
      templeId: 7,
      category: "annadanam",
      description: "Sacred food offering service to devotees",
      duration: "Full day",
      price: "₹10,000",
      time: "11:00 AM - 3:00 PM",
      benefits: ["Merit", "Blessings", "Satisfaction"],
      includes: [
        "Feeding 500 devotees",
        "Complete meal",
        "Kitchen seva",
        "Certificate",
      ],
    },
    {
      id: 17,
      name: "Diwali Special Lakshmi Puja",
      templeId: 5,
      category: "festival",
      description: "Grand Lakshmi puja during Diwali festival",
      duration: "2 hours",
      price: "₹2,000",
      time: "6:00 PM - 8:00 PM",
      benefits: ["Wealth", "Prosperity", "Divine grace"],
      includes: [
        "Special decorations",
        "Lakshmi puja",
        "Aarti",
        "Sweets prasadam",
      ],
    },
    {
      id: 18,
      name: "Vasthra Alankara",
      templeId: 2,
      category: "vasthra",
      description: "Offering of new garments to the deity",
      duration: "1 hour",
      price: "₹1,500",
      time: "10:00 AM - 11:00 AM",
      benefits: ["Divine blessings", "Fulfillment", "Grace"],
      includes: [
        "New silk vasthra",
        "Decoration",
        "Special darshan",
        "Blessed cloth",
      ],
    },
    {
      id: 19,
      name: "Ugadi Festival Seva",
      templeId: 8,
      category: "festival",
      description: "New Year celebration with special rituals",
      duration: "3 hours",
      price: "₹1,800",
      time: "8:00 AM - 11:00 AM",
      benefits: ["New beginnings", "Good fortune", "Success"],
      includes: [
        "Special puja",
        "Ugadi pachadi",
        "New year blessings",
        "Prasadam",
      ],
    },
    {
      id: 20,
      name: "Ayudha Puja",
      templeId: 1,
      category: "festival",
      description: "Worship of instruments and vehicles during Navaratri",
      duration: "1.5 hours",
      price: "₹800",
      time: "4:00 PM - 5:30 PM",
      benefits: ["Tool blessings", "Success in work", "Protection"],
      includes: ["Tools worship", "Special mantras", "Kumkuma", "Prasadam"],
    },
  ];

  const filteredSevas = sevas.filter((seva) => {
    const temple = temples[seva.templeId];
    const matchesCategory =
      selectedCategory === "all" || seva.category === selectedCategory;
    const matchesSearch =
      searchQuery === "" ||
      seva.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      seva.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      temple.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      temple.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
      temple.deity.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Auto-slide gallery images
  useEffect(() => {
    if (selectedSeva) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => {
          const temple = temples[selectedSeva.templeId];
          return (prevIndex + 1) % temple.galleryImages.length;
        });
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [selectedSeva]);

  // Reset image index when modal opens
  useEffect(() => {
    if (selectedSeva) {
      setCurrentImageIndex(0);
    }
  }, [selectedSeva]);

  const handlePrevImage = () => {
    const temple = temples[selectedSeva.templeId];
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? temple.galleryImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    const temple = temples[selectedSeva.templeId];
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % temple.galleryImages.length
    );
  };

  const handleShare = (platform, seva) => {
    const temple = temples[seva.templeId];
    const shareText = `Check out ${seva.name} at ${temple.name}, ${temple.location}`;
    const shareUrl = window.location.href;

    let url = "";
    switch (platform) {
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareUrl
        )}`;
        break;
      case "instagram":
        navigator.clipboard.writeText(`${shareText}\n${shareUrl}`);
        alert("Link copied to clipboard! Share it on Instagram.");
        return;
      case "youtube":
        navigator.clipboard.writeText(`${shareText}\n${shareUrl}`);
        alert("Link copied to clipboard!");
        return;
      default:
        return;
    }

    if (url) {
      window.open(url, "_blank", "width=600,height=400");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-red-50 to-yellow-50 flex flex-col lg:flex-row mt-16 sm:mt-20">
      {/* Mobile Header with Menu Toggle */}
      <div className="lg:hidden bg-white shadow-md p-3 sm:p-4 flex items-center justify-between sticky top-0 z-[60]">
        <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <GiTempleGate className="text-orange-600" />
          Pooja Kits
        </h2>
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="p-2 rounded-lg bg-orange-100 text-orange-600"
        >
          {mobileMenuOpen ? (
            <FiX className="text-xl" />
          ) : (
            <FiSearch className="text-xl" />
          )}
        </button>
      </div>

      {/* Mobile Filter Dropdown */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white shadow-lg border-b border-gray-200 overflow-hidden z-[55]"
          >
            <div className="p-4 max-h-[70vh] overflow-y-auto">
              <h3 className="text-sm font-bold text-gray-800 mb-3 flex items-center gap-2">
                <GiTempleGate className="text-orange-600" />
                Categories
              </h3>
              <div className="grid grid-cols-2 gap-2">
                {sevaCategories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      setMobileMenuOpen(false);
                    }}
                    className={`flex flex-col items-center justify-center gap-2 px-3 py-3 rounded-xl font-medium transition-all duration-200 text-xs ${
                      selectedCategory === category.id
                        ? `bg-gradient-to-r ${category.color} text-white shadow-lg transform scale-105`
                        : "text-gray-700 bg-gray-50 hover:bg-gray-100 border border-gray-200"
                    }`}
                  >
                    <span className="text-2xl">{category.icon}</span>
                    <span className="text-center leading-tight">
                      {category.name}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Desktop Left Sidebar - Filters */}
      <div className="hidden lg:block w-56 xl:w-72 bg-white shadow-lg border-r border-gray-200 flex-shrink-0 self-start sticky top-20 mt-6 mr-4 rounded-lg max-h-[calc(100vh-6rem)] overflow-y-auto">
        <div className="p-4 lg:p-5 xl:p-6">
          <h3 className="text-base lg:text-lg font-bold text-gray-800 mb-3 lg:mb-4 flex items-center gap-2">
            <GiTempleGate className="text-orange-600 text-lg lg:text-xl" />
            Categories
          </h3>
          <div className="space-y-2">
            {sevaCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-all duration-200 text-sm ${
                  selectedCategory === category.id
                    ? `bg-gradient-to-r ${category.color} text-white shadow-lg transform scale-105`
                    : "text-gray-700 hover:bg-gray-50 border border-gray-200 hover:border-gray-300"
                }`}
              >
                <span className="text-xl flex-shrink-0">{category.icon}</span>
                <span className="truncate text-left">{category.name}</span>
                {selectedCategory === category.id && (
                  <FiCheck className="ml-auto flex-shrink-0" />
                )}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto lg:ml-0">
        {/* Hero Section */}
        <div className="relative bg-gradient-to-r from-orange-600 via-red-600 to-orange-700 text-white py-4 sm:py-6 lg:py-8">
          <div className="container mx-auto px-3 sm:px-4 lg:px-6">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center"
            >
              <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold mb-1 sm:mb-2">
              Authentic Pooja Kits

              </h1>
              <p className="text-xs sm:text-sm lg:text-base text-orange-100 max-w-2xl mx-auto px-2 sm:px-4">
                Complete pooja kits with all authentic items, delivered fresh to your doorstep. Perfect for festivals, ceremonies, and daily worship.
              </p>
            </motion.div>

            {/* Search Bar */}
            <div className="mt-3 sm:mt-4 lg:mt-6 max-w-xl mx-auto relative">
              <FiSearch className="absolute left-3 lg:left-4 top-1/2 -translate-y-1/2 text-gray-400 text-base lg:text-lg" />
              <input
                type="text"
                placeholder="Search pooja kits, categories, or ceremonies..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-9 sm:pl-10 lg:pl-11 pr-9 sm:pr-10 lg:pr-4 py-2 sm:py-2.5 lg:py-3 rounded-full text-gray-800 focus:outline-none focus:ring-2 lg:focus:ring-3 focus:ring-orange-300 shadow-xl text-xs sm:text-sm"
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  <FiX />
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Sevas Grid */}
        <div className="container mx-auto px-2 sm:px-3 lg:px-6 py-3 sm:py-4 lg:py-6">
          {filteredSevas.length === 0 ? (
            <div className="text-center py-12 lg:py-20">
              <GiTempleGate className="text-4xl lg:text-6xl text-gray-300 mx-auto mb-4" />
              <h3 className="text-xl lg:text-2xl font-bold text-gray-600 mb-2">
                No sevas found
              </h3>
              <p className="text-sm lg:text-base text-gray-500 mb-6">
                Try adjusting your search or filter
              </p>
              <button
                onClick={() => {
                  setSearchQuery("");
                  setSelectedCategory("all");
                }}
                className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 lg:px-8 py-2.5 lg:py-3 rounded-full font-semibold hover:from-orange-600 hover:to-red-700 transition-all duration-300 shadow-lg text-sm"
              >
                Reset Filters
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-2.5 sm:gap-3 lg:gap-4">
              {filteredSevas.map((seva, index) => {
                const temple = temples[seva.templeId];
                return (
                  <motion.div
                    key={seva.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.03 }}
                    className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 group relative"
                  >
                    {/* Share Icon */}
                    <div className="absolute top-2 right-2 z-10">
                      <div className="relative">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShareSevaId(
                              shareSevaId === seva.id ? null : seva.id
                            );
                          }}
                          className="bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-lg hover:bg-white transition-all duration-200"
                        >
                          <FiShare2 className="text-orange-600 text-sm" />
                        </button>

                        {/* Social Media Icons */}
                        <AnimatePresence>
                          {shareSevaId === seva.id && (
                            <motion.div
                              initial={{ opacity: 0, scale: 0.8, y: -10 }}
                              animate={{ opacity: 1, scale: 1, y: 0 }}
                              exit={{ opacity: 0, scale: 0.8, y: -10 }}
                              className="absolute top-full right-0 mt-2 bg-white rounded-lg shadow-xl p-2 flex flex-col gap-2"
                            >
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShare("facebook", seva);
                                }}
                                className="p-2 rounded-full bg-blue-50 hover:bg-blue-100 transition-colors"
                              >
                                <FaFacebook className="text-blue-600 text-lg" />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShare("instagram", seva);
                                }}
                                className="p-2 rounded-full bg-pink-50 hover:bg-pink-100 transition-colors"
                              >
                                <FaInstagram className="text-pink-600 text-lg" />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShare("youtube", seva);
                                }}
                                className="p-2 rounded-full bg-red-50 hover:bg-red-100 transition-colors"
                              >
                                <FaYoutube className="text-red-600 text-lg" />
                              </button>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    </div>

                    {/* Card Image - Temple Profile Image Only */}
                    <div
                      onClick={() => setSelectedSeva(seva)}
                      className="relative h-24 sm:h-28 overflow-hidden cursor-pointer"
                    >
                      <img
                        src={temple?.profileImage}
                        alt={temple?.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                      {/* Temple Info Overlay */}
                      <div className="absolute bottom-0 left-0 right-0 p-2 text-white">
                        <p className="text-[11px] sm:text-xs font-semibold truncate">
                          {temple?.name}
                        </p>
                        <p className="text-[10px] sm:text-xs opacity-90 truncate flex items-center gap-1">
                          <FiMapPin className="flex-shrink-0 text-[9px] sm:text-[10px]" />
                          {temple?.location}
                        </p>
                      </div>
                    </div>

                    {/* Card Body */}
                    <div
                      onClick={() => setSelectedSeva(seva)}
                      className="p-2.5 sm:p-3 cursor-pointer"
                    >
                      <h3 className="text-xs sm:text-sm font-bold text-gray-800 mb-1 truncate">
                        {seva.name}
                      </h3>
                      <p className="text-[11px] sm:text-xs text-gray-600 mb-2 line-clamp-2">
                        {seva.description}
                      </p>

                      {/* Quick Info */}
                      <div className="space-y-1 mb-2">
                        <div className="flex items-center gap-1.5 text-[11px] sm:text-xs text-gray-600">
                          <GiLotus className="text-orange-600 flex-shrink-0 text-xs sm:text-sm" />
                          <span className="truncate">{temple?.deity}</span>
                        </div>
                        <div className="flex items-center gap-1.5 text-[11px] sm:text-xs text-gray-600">
                          <FiClock className="text-orange-600 flex-shrink-0 text-xs sm:text-sm" />
                          <span className="truncate">{seva.duration}</span>
                        </div>
                      </div>

                      {/* Benefits */}
                      <div className="flex flex-wrap gap-1 mb-2.5 sm:mb-3">
                        {seva.benefits.slice(0, 2).map((benefit, idx) => (
                          <span
                            key={idx}
                            className="px-1.5 sm:px-2 py-0.5 bg-orange-50 text-orange-700 rounded-full text-[9px] sm:text-[10px] font-medium"
                          >
                            ✨ {benefit}
                          </span>
                        ))}
                      </div>

                      {/* View Details Button */}
                      <button className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white py-1.5 sm:py-2 rounded-lg font-semibold hover:from-orange-600 hover:to-red-700 transition-all duration-300 shadow-md text-[11px] sm:text-xs flex items-center justify-center gap-1">
                        View Details
                      </button>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Full Screen Details Modal - (continuing in next part due to length) */}
      <AnimatePresence>
        {selectedSeva && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedSeva(null)}
            className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40 flex items-center justify-center"
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
              className="bg-white w-full h-full overflow-auto"
            >
              {/* Modal Header with Close Button */}
              <div className="sticky top-0 bg-gradient-to-r from-orange-600 to-red-600 text-white p-3 sm:p-4 lg:p-6 z-30 shadow-lg mt-20">
                <button
                  onClick={() => setSelectedSeva(null)}
                  className="absolute top-2 right-2 sm:top-4 sm:right-4 p-1.5 sm:p-2 hover:bg-white/20 rounded-full transition-colors"
                >
                  <FiX className="text-xl sm:text-2xl" />
                </button>
                <h2 className="text-lg sm:text-xl lg:text-2xl font-bold mb-1 sm:mb-2 pr-10 sm:pr-12">
                  {selectedSeva.name}
                </h2>
                <p className="text-orange-100 text-xs sm:text-sm">
                  {temples[selectedSeva.templeId]?.name}
                </p>
                <p className="text-orange-100 text-xs flex items-center gap-1 mt-1">
                  <FiMapPin /> {temples[selectedSeva.templeId]?.location}
                </p>
              </div>

              {/* Modal Body */}
              <div className="p-3 sm:p-4 lg:p-6 space-y-4 sm:space-y-5 lg:space-y-6 max-w-6xl mx-auto">
                {/* Image Gallery Slider */}
                <div className="relative rounded-xl overflow-hidden shadow-2xl">
                  <div className="relative h-48 sm:h-64 lg:h-80">
                    <AnimatePresence mode="wait">
                      <motion.img
                        key={currentImageIndex}
                        src={
                          temples[selectedSeva.templeId]?.galleryImages[
                            currentImageIndex
                          ]
                        }
                        alt={`${temples[selectedSeva.templeId]?.name} - Image ${
                          currentImageIndex + 1
                        }`}
                        className="w-full h-full object-cover"
                        initial={{ opacity: 0, x: 100 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -100 }}
                        transition={{ duration: 0.5 }}
                      />
                    </AnimatePresence>

                    {/* Navigation Buttons */}
                    <button
                      onClick={handlePrevImage}
                      className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm p-2 sm:p-3 rounded-full shadow-lg hover:bg-white transition-all duration-200 group"
                    >
                      <FiChevronLeft className="text-orange-600 text-lg sm:text-xl group-hover:scale-110 transition-transform" />
                    </button>
                    <button
                      onClick={handleNextImage}
                      className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm p-2 sm:p-3 rounded-full shadow-lg hover:bg-white transition-all duration-200 group"
                    >
                      <FiChevronRight className="text-orange-600 text-lg sm:text-xl group-hover:scale-110 transition-transform" />
                    </button>

                    {/* Image Indicators */}
                    <div className="absolute bottom-2 sm:bottom-4 left-1/2 -translate-x-1/2 flex gap-1 sm:gap-2">
                      {temples[selectedSeva.templeId]?.galleryImages.map(
                        (_, idx) => (
                          <button
                            key={idx}
                            onClick={() => setCurrentImageIndex(idx)}
                            className={`w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full transition-all duration-300 ${
                              idx === currentImageIndex
                                ? "bg-white w-6 sm:w-8"
                                : "bg-white/50 hover:bg-white/75"
                            }`}
                          />
                        )
                      )}
                    </div>

                    {/* Image Counter */}
                    <div className="absolute top-2 right-2 sm:top-4 sm:right-4 bg-black/60 backdrop-blur-sm text-white px-2 py-0.5 sm:px-3 sm:py-1 rounded-full text-xs sm:text-sm">
                      {currentImageIndex + 1} /{" "}
                      {temples[selectedSeva.templeId]?.galleryImages.length}
                    </div>
                  </div>
                </div>

                {/* Description */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2 flex items-center gap-2">
                    <GiLotus className="text-orange-600" />
                    About This Seva
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {selectedSeva.description}
                  </p>
                </div>

                {/* What's Included */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                    <FiCheck className="text-orange-600" />
                    What's Included
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {selectedSeva.includes.map((item, idx) => (
                      <div
                        key={idx}
                        className="flex items-center gap-2 text-sm text-gray-700"
                      >
                        <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Benefits */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
                    <FiStar className="text-orange-600" />
                    Spiritual Benefits
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {selectedSeva.benefits.map((benefit, idx) => (
                      <span
                        key={idx}
                        className="px-4 py-2 bg-gradient-to-r from-orange-50 to-red-50 text-orange-700 rounded-full text-sm font-medium border border-orange-200"
                      >
                        ✨ {benefit}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Temple Details */}
                <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-5 border border-orange-100">
                  <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <GiTempleGate className="text-orange-600" />
                    Temple Information
                  </h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Temple</p>
                      <p className="font-semibold text-gray-800 text-sm">
                        {temples[selectedSeva.templeId]?.name}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Deity</p>
                      <p className="font-semibold text-gray-800 text-sm">
                        {temples[selectedSeva.templeId]?.deity}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Location</p>
                      <p className="font-semibold text-gray-800 text-sm flex items-center gap-1">
                        <FiMapPin className="text-orange-600" />
                        {temples[selectedSeva.templeId]?.location}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">
                        Temple Timings
                      </p>
                      <p className="font-semibold text-gray-800 text-xs">
                        {temples[selectedSeva.templeId]?.timings}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Contact</p>
                      <p className="font-semibold text-gray-800 text-sm flex items-center gap-1">
                        <FiPhone className="text-orange-600" />
                        {temples[selectedSeva.templeId]?.contact}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600 mb-1">Email</p>
                      <p className="font-semibold text-gray-800 text-sm flex items-center gap-1">
                        <FiMail className="text-orange-600" />
                        {temples[selectedSeva.templeId]?.email}
                      </p>
                    </div>
                  </div>

                  <div className="mt-4">
                    <p className="text-xs text-gray-600 mb-1">Address</p>
                    <p className="text-gray-700 text-sm">
                      {temples[selectedSeva.templeId]?.address}
                    </p>
                  </div>

                  {/* Temple Description */}
                  <div className="mt-4">
                    <p className="text-sm text-gray-700 leading-relaxed">
                      {temples[selectedSeva.templeId]?.description}
                    </p>
                  </div>

                  {/* Facilities */}
                  {temples[selectedSeva.templeId]?.facilities && (
                    <div className="mt-4">
                      <p className="text-xs text-gray-600 mb-2">
                        Facilities Available
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {temples[selectedSeva.templeId].facilities.map(
                          (facility, idx) => (
                            <span
                              key={idx}
                              className="px-3 py-1 bg-white text-gray-700 rounded-full text-xs font-medium border border-gray-200"
                            >
                              ✓ {facility}
                            </span>
                          )
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
